import api from "../http";

export default class ApiFooterLicenceText {
  static async getApiFooterLicenceText(url) {
    return api.get(url)
  }
}